import React from "react";

export default function PrivacyPolicy() {
  return (
    <main className="container">
      <section className="request">
        <h2>Privacy Policy</h2>
        <p className="sub">
          Effective date: <strong>December 21, 2025</strong>
        </p>

        <div className="card" style={{ maxWidth: 900 }}>
          <div className="card-body">
            <h3>Summary</h3>
            <p>
              We collect limited information to respond to requests, provide
              services, process payments, and secure accounts. We do not sell
              personal information.
            </p>
          </div>
        </div>

        <div className="grid-1">
          <h3 style={{ color: "var(--ua-blue)", marginTop: 0 }}>
            Information We Collect
          </h3>
          <ul>
            <li>
              <strong>Contact details</strong> you provide (name, email, phone,
              address, message content).
            </li>
            <li>
              <strong>Account details</strong> if you create an account
              (username, email, security settings such as MFA).
            </li>
            <li>
              <strong>Payment information</strong> handled by our payment
              processors (we do not store full card numbers).
            </li>
            <li>
              <strong>Technical data</strong> (IP address, device/browser info,
              and cookies needed for site functionality and security).
            </li>
          </ul>

          <h3 style={{ color: "var(--ua-blue)" }}>How We Use Information</h3>
          <ul>
            <li>To respond to inquiries and provide quotes/services.</li>
            <li>To process payments and send confirmations/receipts.</li>
            <li>
              To secure accounts and prevent fraud/abuse (authentication,
              session cookies, MFA).
            </li>
            <li>To improve site reliability and troubleshoot issues.</li>
          </ul>

          <h3 style={{ color: "var(--ua-blue)" }}>How We Share Information</h3>
          <p>We share information only as needed to operate the website and deliver services, such as:</p>
          <ul>
            <li><strong>Payment processing</strong> (e.g., PayPal).</li>
            <li><strong>Email delivery</strong> (e.g., email relay providers used to send account/security and service communications).</li>
            <li><strong>Hosting/infrastructure</strong> providers that support our systems.</li>
            <li><strong>Legal</strong> compliance when required by law.</li>
          </ul>

          <h3 style={{ color: "var(--ua-blue)" }}>Cookies</h3>
          <p>
            We use cookies for essential functionality (sessions, security) and
            may use analytics cookies to understand site usage. You can control
            cookies through your browser settings.
          </p>

          <h3 style={{ color: "var(--ua-blue)" }}>Data Retention</h3>
          <p>
            We keep personal information only as long as needed for the purposes
            described above, including legal, accounting, and security
            requirements.
          </p>

          <h3 style={{ color: "var(--ua-blue)" }}>Your Choices</h3>
          <ul>
            <li>
              You may request access to or deletion of your account information
              (subject to legal requirements).
            </li>
            <li>
              You may opt out of marketing emails (transactional/security emails
              may still be sent).
            </li>
          </ul>

          <h3 style={{ color: "var(--ua-blue)" }}>Children’s Privacy</h3>
          <p>
            Our services are not directed to children under 13, and we do not
            knowingly collect personal information from children.
          </p>

          <h3 style={{ color: "var(--ua-blue)" }}>Contact</h3>
          <p>
            Questions? Contact us at <strong>service@azfacilitymanagement.com</strong>.
          </p>
        </div>
      </section>
    </main>
  );
}